import BadgeIcon1 from '@assets/svgs/exam/badge1.svg'
import BadgeIcon2 from '@assets/svgs/exam/badge2.svg'
import BadgeIcon3 from '@assets/svgs/exam/badge3.svg'
import BadgeIcon4 from '@assets/svgs/exam/badge4.svg'
import BadgeIcon5 from '@assets/svgs/exam/badge5.svg'
import ScoreWrap1 from '@assets/images/exam/score-wrap1.png'
import ScoreWrap2 from '@assets/images/exam/score-wrap2.png'
import ScoreWrap3 from '@assets/images/exam/score-wrap3.png'
import ScoreWrap4 from '@assets/images/exam/score-wrap4.png'
import ScoreWrap5 from '@assets/images/exam/score-wrap5.png'
import BadPauseIcon from '@assets/svgs/exam/bad-pause.svg'
import SpeechRate1 from '@assets/svgs/exam/speech-rate1.svg'
import SpeechRate2 from '@assets/svgs/exam/speech-rate2.svg'
import SpeechRate3 from '@assets/svgs/exam/speech-rate3.svg'
import SpeechRate4 from '@assets/svgs/exam/speech-rate4.svg'

export const getScoreWrap = (score: number) => {
  if (score < 4) return ScoreWrap1
  if (score < 6) return ScoreWrap2
  if (score < 7) return ScoreWrap3
  if (score < 9) return ScoreWrap4
  if (score >= 9) return ScoreWrap5
}
export const getBadgeByScore = (score: number) => {
  if (score <= 3) return BadgeIcon1
  if (score <= 5) return BadgeIcon2
  if (score <= 6) return BadgeIcon3
  if (score <= 8) return BadgeIcon4
  if (score <= 9) return BadgeIcon5
}
export const getSpeedRateBadge = (SpeedRate: number) => {
  if (SpeedRate < 60) return SpeechRate1
  if ((SpeedRate >= 60 && SpeedRate <= 89) || SpeedRate > 210)
    return SpeechRate2
  if (SpeedRate >= 90 && SpeedRate <= 119) return SpeechRate3
  if (SpeedRate >= 120 && SpeedRate <= 180) return SpeechRate4
  if (SpeedRate >= 181 && SpeedRate <= 210) return SpeechRate3
}
export const getColorBySpeedRate = (SpeedRate: number) => {
  if (SpeedRate < 60) return '#1F1F1F'
  if ((SpeedRate >= 60 && SpeedRate <= 89) || SpeedRate > 210) return '#EC652C'
  if (SpeedRate >= 90 && SpeedRate <= 119) return '#1890FF'
  if (SpeedRate >= 120 && SpeedRate <= 180) return '#14AE5C'
  if (SpeedRate >= 181 && SpeedRate <= 210) return '#1890FF'
}
export const getColorByScore = (score: number) => {
  if (score <= 3) return '#1F1F1F'
  if (score <= 5) return '#EC652C'
  if (score <= 6) return '#1890FF'
  if (score <= 8) return '#14AE5C'
  if (score <= 9) return '#722ED1'
}
export const getCharColorByScore = (score: number) => {
  if (score <= 0.49) return '#B74645'
  if (score <= 0.75) return '#CCA400'
  return '#434343'
}
export const getColorGradientByScore = (score: number) => {
  if (score <= 3) return 'linear-gradient(180deg, #B2B2B2 0%, #999 100%)'
  if (score <= 5)
    return 'linear-gradient(174deg, #FFC531 4.83%, #FF9500 95.23%)'
  if (score <= 6) return 'linear-gradient(180deg, #00C2FF 0%, #00A3FF 100%)'
  if (score <= 8)
    return 'linear-gradient(144deg, #17F58A 8.55%, #06934F 91.45%)'
  if (score <= 9)
    return 'linear-gradient(144deg, #F195FC 8.55%, #8D39DB 91.45%)'
}
export const getIconByChar = (Char: any) => {
  if (Char === '~') return BadPauseIcon
}
